import React from 'react'

export const NotFoundPage = () => {
  return (
    <div>PageNotFound</div>
  )
}
